import { render, staticRenderFns } from "./offerHelp.vue?vue&type=template&id=193bbf70&scoped=true&"
import script from "./offerHelp.vue?vue&type=script&lang=js&"
export * from "./offerHelp.vue?vue&type=script&lang=js&"
import style0 from "./offerHelp.vue?vue&type=style&index=0&id=193bbf70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193bbf70",
  null
  
)

export default component.exports